import * as React from 'react';

import { Item } from '../../components';

const StaffMember = props => {
  const { name, attributes } = props.member;
  const position = attributes.find(attr => attr.name.toLowerCase().includes('position'));

  return <Item name={name} value={position.value} />;
};

export default StaffMember;



// WEBPACK FOOTER //
// ./src/pages/AboutUs/StaffMember.js